import React, { useState, useEffect, Fragment } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import Host from "../../Components/Host";
import HelmetComponent from "../../Components/HelmetComponent";
function Careers() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  return (
    <>
      <HelmetComponent title={"Careers"} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h1 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>{t("careers")}</h1>
                <p>Welcome to the careers page of TheGlobalGenie. </p>
                <p>
                  We are building one clear vision: making world class global products easily accessible to shoppers in
                  India. To do that well, we need people who are curious, driven and excited about e–commerce,
                  technology and customer experience.
                </p>

                <p>At TheGlobalGenie, you will:</p>
                <p>- Work with a small, fast moving team that loves ownership</p>
                <p>- Collaborate on real impact projects across product, operations, marketing and customer success</p>
                <p>- Help shape the future of cross border online shopping for Indian consumers</p>
                <p>
                  If you enjoy solving problems, experimenting with new ideas and building things from the ground up,
                  you will fit right in here.
                </p>
                <p>
                  Join us on this journey and unlock your potential in a fast paced, challenging and rewarding
                  environment.
                </p>
                <p>
                  Explore our current openings and take the first step towards an exciting career with TheGlobalGenie.
                </p>
                <p>To apply or share your profile, write to us at:</p>
                <p>Email: cs@theglobalgenie.com</p>

                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Careers;
